import { budgetService } from "../services/budget.service";
import { appConstants, months } from "../helpers/constants";

export const budgetActions = {
  getBudgetList,
  getBudgetList2,
  getBudgetList3,
  getMonthlyBudget,
};

function getBudgetList(obj) {
  return (dispatch, getState) => {
    if (getState().budgetReducer.budgets === null) {
      dispatch({
        type: appConstants.REQUESTING_BUDGET,
      });

      budgetService.getBudgetList(obj).then(
        (response) => {
          const budgets = response;
          // Convert month from id format to string value format
          for (let i = 0; i < budgets.length; i++) {
            if (budgets[i].months) {
              const monthsArr = budgets[i].months
                .split(",")
                .map((item) => Number(item));
              const monthsArr2 = [];
              months.forEach((item, i) => {
                let index = monthsArr.indexOf(parseInt(item.id));
                if (index > -1) {
                  monthsArr2.push(months[i].name);
                }
              });
              budgets[i].months = monthsArr2.join(", ");
            }
          }
          // End converting task
          dispatch({
            type: appConstants.GET_BUDGET_SUCCESS,
            budgetList: budgets,
          });
        },
        (error) => {
          dispatch({
            type: appConstants.GET_BUDGET_FAILED,
            error,
          });
        }
      );
    }
  };
}

function getBudgetList2(obj) {
  return (dispatch) => {
    dispatch({
      type: appConstants.REQUESTING_BUDGET,
    });
    budgetService.getBudgetList(obj).then(
      (response) => {
        if(response.data.status == 200){
          const budgets = response.data.result;
          // Convert month from id format to string value format
          for (let i = 0; i < budgets.length; i++) {
            if (budgets[i].months) {
              const monthsArr = budgets[i].months
                .split(",")
                .map((item) => Number(item));
              const monthsArr2 = [];
              months.forEach((item, i) => {
                let index = monthsArr.indexOf(parseInt(item.id));
                if (index > -1) {
                  monthsArr2.push(months[i].name);
                }
              });
              budgets[i].months = monthsArr2.join(", ");
            }
          }
          // End converting task
          dispatch({
            type: appConstants.GET_BUDGET_SUCCESS,
            budgetList: budgets,
          });
  
        } else {
          dispatch({
            type: appConstants.GET_BUDGET_FAILED,
            error: response.data.message,
          });
        }
       
      },
      (error) => {
        dispatch({
          type: appConstants.GET_BUDGET_FAILED,
          error,
        });
      }
    );
  };
}

// Fetch Archives.
function getBudgetList3(obj) {
  return (dispatch) => {
    dispatch({
      type: appConstants.REQUESTING_BUDGET,
    });

    budgetService.getBudgetList(obj).then(
      (response) => {
        const budgets = response.data.result;
        // Convert month from id format to string value format
        for (let i = 0; i < budgets.length; i++) {
          if (budgets[i].months) {
            const monthsArr = budgets[i].months
              .split(",")
              .map((item) => Number(item));
            const monthsArr2 = [];
            months.forEach((item, i) => {
              let index = monthsArr.indexOf(parseInt(item.id));
              if (index > -1) {
                monthsArr2.push(months[i].name);
              }
            });
            budgets[i].months = monthsArr2.join(", ");
          }
        }
        // End converting task
        dispatch({
          type: appConstants.GET_ARCHIVE_BUDGET_SUCCESS,
          budgetList: budgets,
        });
      },
      (error) => {
        dispatch({
          type: appConstants.GET_BUDGET_FAILED,
          error,
        });
      }
    );
  };
}


function getMonthlyBudget(obj) {
  return (dispatch, getState) => {
    if (
      (obj.budget_type == "expense" &&
        (getState().budgetReducer.monthlyExpenseList === null ||
          obj.callFrom === "server")) ||
      (obj.budget_type == "income" &&
        (getState().budgetReducer.totalIncome === null ||
          obj.callFrom === "server"))
    ) {
      dispatch({
        type: appConstants.REQUESTING_MONTLY_BUDGET,
      });

      budgetService.getMonthlyBudget(obj).then(
        (response) => {
          if(response.data && response.data.status==200){
            const budgets = response.data.result;
            const total_income = response.data.total_income;
            // Convert month from id format to string value format
            let totalBudget = 0.0;
            let totalSpent = 0.0;
            for (let i = 0; i < budgets.length; i++) {
              //Calculate total budget
              totalBudget = totalBudget + parseFloat(budgets[i].amount);
              // Change format of months value
              if (budgets[i].months) {
                const monthsArr = budgets[i].months
                  .split(",")
                  .map((item) => Number(item));
                const monthsArr2 = [];
                months.forEach((item, i) => {
                  let index = monthsArr.indexOf(parseInt(item.id));
                  if (index > -1) {
                    monthsArr2.push(months[i].name);
                  }
                });
                budgets[i].months = monthsArr2.join(", ");
              }
              // Calculate sum of spent amount.
              for (let j = 0; j < budgets[i].transactions.length; j++) {
                if(budgets[i].transactions[j].account_type != 2){
                  // Calculate total spent
                  totalSpent =
                    totalSpent + parseFloat(budgets[i].transactions[j].amount);
                }
              }
            }
            // End converting task
            if (obj.budget_type == "expense") {
              dispatch({
                type: appConstants.GET_MONTHLY_EXPENSE,
                monthlyExpenseList: budgets,
                totalBudget: totalBudget.toFixed(2),
                totalSpent: totalSpent.toFixed(2),
                totalIncome: total_income,
              });
            } else {
              dispatch({
                type: appConstants.GET_MONTHLY_INCOME,
                monthlyIncomeList: budgets,
                totalIncome: totalSpent.toFixed(2),
              });
            }
            
          }
          else {
            dispatch({
              type: appConstants.INVALID_REQUEST,
              error: response.data.message,
            });
            }
        },
        (error) => {
          dispatch({
            type: appConstants.GET_MONTHLY_BUDGET_FAILED,
            error,
          });
        }
      );
    }
  };
}
